export const signatoryCompanyInfo = {
  companyName: "",
  countryOfIncorporation: "AE",
  hasDiplomaticPassport: false,
  hasProminentPosition: false,
  isMemberofRulingFamily: false,
  tradeLicenseNo: "",
  dateOfIncorporation: ""
};

export const kycAnnexure = {
  workItemNumber: "",
  companyName: "",
  skillBasedCategory: "",
  signatoryName: "",
  signatoryDetails: [
    {
      signatoryName: "",
      education: "",
      backgroundInfo: ""
    }
  ],
  businessModel: "",
  isUltimateBeneficiary: "",
  bankDetails: [
    {
      bankName: "",
      isStatementAvailable: "",
      bankStatementRemark: "",
      bankStatementFrom: "",
      bankStatementTo: ""
    }
  ],
  antiMoneyLaundering: "yes",
  poaCountry: [""],
  riskIndustries: [""],
  clientDealingCountry: [""],
  audioVideoKycVerification: "NA",
  signatoryEIDinfo: "yes",
  signatoryEIDinfoRemarks: "",
  goAmlRegistration: "NA",
  goAmlRegistrationNumber: "",
  goAmlIndustry: [],
  noticeToCounterfeit: "",
  roName: "",
  roEmployeeId: "",
  kycVerificationDate: "",
  kycVerificationTime: "",
  kycVerificationLocation: "",
  kycVerificationotherLocation: ""
};
